import { render, staticRenderFns } from "./PostCreator.vue?vue&type=template&id=5c98c025&"
import script from "./PostCreator.vue?vue&type=script&lang=js&"
export * from "./PostCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports